import { useFlowAnalyticsStore } from '@/v2/domains/Analytics/stores/flowAnalytics.store';

import useTrackPlausibleEvent from './useTrackPlausibleEvent.hook';
import { FlowEvent, PlausibleEvent } from '@/v2/domains/Analytics/types/common';

export default function useTrackPlausibleFlowEvent() {
  const { getRunFlowId } = useFlowAnalyticsStore();
  const trackEvent = useTrackPlausibleEvent();

  const trackFlowEvent = <T extends FlowEvent<string, string, PlausibleEvent>>({
    event,
    flow,
    section,
    step,
    stepIndex,
    option,
  }: T) => {
    const optionValue = option ? { option } : {};

    trackEvent(event, {
      flow,
      runFlowId: getRunFlowId(flow),
      section,
      step,
      stepIndex,
      ...optionValue,
    });
  };

  return trackFlowEvent;
}
